import React from 'react';
import { BarChart } from '@mui/x-charts';
import { ProposalByUser } from '../../DashboardPage';

interface Props {
  dataset: ProposalByUser[];
}

export const ProposalsByUser = ({ dataset }: Props) => {
  return (
    <BarChart
      height={500}
      dataset={dataset}
      series={[{ label: 'No. Proposals', dataKey: 'total' }]}
      xAxis={[{ scaleType: 'band', dataKey: 'fullName', label: 'Users' }]}
    />
  );
};
